var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter, OnInit, SimpleChanges } from "@angular/core";
import * as moment from 'moment-timezone';
import { NgbDatepicker, NgbDatepickerI18n, NgbDropdown } from "@ng-bootstrap/ng-bootstrap";
import { ControlValueAccessor } from "@angular/forms";
var I18n = /** @class */ (function () {
    function I18n() {
        this.language = 'ru';
        this.I18N_VALUES = {
            'ru': {
                weekdays: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
                months: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
            }
        };
    }
    return I18n;
}());
export { I18n };
var CustomDatepickerI18n = /** @class */ (function (_super) {
    __extends(CustomDatepickerI18n, _super);
    function CustomDatepickerI18n(_i18n) {
        var _this = _super.call(this) || this;
        _this._i18n = _i18n;
        return _this;
    }
    CustomDatepickerI18n.prototype.getWeekdayShortName = function (weekday) {
        return this._i18n.I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
    };
    CustomDatepickerI18n.prototype.getMonthShortName = function (month) {
        return this._i18n.I18N_VALUES[this._i18n.language].months[month - 1];
    };
    CustomDatepickerI18n.prototype.getMonthFullName = function (month) {
        return this.getMonthShortName(month);
    };
    CustomDatepickerI18n.prototype.getDayAriaLabel = function (date) {
        return date.year + "-" + date.month + "-" + date.day;
    };
    return CustomDatepickerI18n;
}(NgbDatepickerI18n));
export { CustomDatepickerI18n };
var DatetimepickerComponent = /** @class */ (function () {
    function DatetimepickerComponent() {
        this.propagateChange = function () { };
        this.dt = moment().format('DD-MM-YYYY');
        this.dtChange = new EventEmitter();
        this.format = 'YYYY-MM-DD'; //'DD.MM.YYYY HH:mm';
        this.enabledTime = false;
        this.disabled = false;
        this.maxDate = { year: 3000, month: 12, day: 31 };
        this.modelD = {
            year: 2017,
            month: 11,
            day: 8
        };
        this.modelT = {
            hour: 0,
            minute: 0
        };
        this.visibleTimepicker = false;
    }
    DatetimepickerComponent.prototype.ngOnInit = function () {
        /*
        if(!this.minDate) {
            const dt = moment();
            this.minDate = {year: dt.year(), month: dt.month() + 1, day: dt.date()};
        }
        */
        if (this.enabledTime) {
            var dt = moment(this.dt, this.format);
            this.modelD = { year: dt.year(), month: dt.month() + 1, day: dt.date() };
            this.modelT = { hour: dt.hour(), minute: dt.minute() };
            this.visibleTimepicker = true;
        }
        else if (this.dt && this.dt.length == 10) {
            var dt = moment(this.dt, this.format);
            this.modelD = { year: dt.year(), month: dt.month() + 1, day: dt.date() };
            this.visibleTimepicker = false;
        }
        else {
            var dt = moment();
            this.modelD = { year: dt.year(), month: dt.month() + 1, day: dt.date() };
            this.visibleTimepicker = false;
        }
    };
    DatetimepickerComponent.prototype.ngOnChanges = function (changes) {
        if (changes.dt && changes.dt.currentValue != '') {
            var dt = moment(this.dt, this.format);
            this.modelD = { year: dt.year(), month: (dt.month() + 1), day: dt.date() };
            this.myDatepicker.navigateTo({
                year: this.modelD.year,
                month: this.modelD.month
            });
        }
    };
    DatetimepickerComponent.prototype.showTimepicker = function () {
        this.visibleTimepicker = !this.visibleTimepicker;
    };
    DatetimepickerComponent.prototype.onInputClick = function (event) {
        event.stopPropagation();
        if (this.disabled) {
            return;
        }
        this.myDropdown.open();
        this.myDatepicker.navigateTo(this.modelD);
    };
    DatetimepickerComponent.prototype.onDatepickerClick = function (event) {
        if (event.target.className.indexOf('bg-primary') != -1) {
            this.myDropdown.close();
            var dt = moment([this.modelD.year, (this.modelD.month - 1), this.modelD.day]);
            if (this.visibleTimepicker && this.modelT.hour != null) {
                dt.hour(this.modelT.hour);
                dt.minute(this.modelT.minute);
                this.dt = dt.format(this.format);
            }
            else {
                this.dt = dt.format(this.format);
            }
            this.dtChange.emit(this.dt);
            this.propagateChange(this.dt);
        }
    };
    DatetimepickerComponent.prototype.writeValue = function (value) {
        if (value) {
            this.dt = value;
        }
    };
    DatetimepickerComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    DatetimepickerComponent.prototype.registerOnTouched = function () {
    };
    // Не до конца понятно почему без явного отслеживания (input), при ручном вводе значения, не меняется dt
    DatetimepickerComponent.prototype.onInput = function (event) {
        this.dt = event.target.value;
    };
    return DatetimepickerComponent;
}());
export { DatetimepickerComponent };
